module.exports = __webpack_public_path__ + "static/media/vanik.c5710038.jpg";